const PRIORITY_LOW = 'low'
const PRIORITY_NORMAL = 'normal'
const PRIORITY_HIGH = 'high'

const PRIORITY_CODES = [PRIORITY_LOW, PRIORITY_NORMAL, PRIORITY_HIGH]

const mapPriorityCodeToApiValue = priorityCode => {
  if (priorityCode === PRIORITY_LOW) {
    return 1
  }
  if (priorityCode === PRIORITY_NORMAL) {
    return 2
  }
  if (priorityCode === PRIORITY_HIGH) {
    return 3
  }

  return null
}

const mapApiPriorityToCode = priorityValue => {
  if (priorityValue === null || priorityValue === undefined || priorityValue === '') {
    return null
  }

  const normalized = Number(priorityValue)
  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null
  }

  if (normalized <= 1) {
    return PRIORITY_LOW
  }

  if (normalized <= 2) {
    return PRIORITY_NORMAL
  }

  return PRIORITY_HIGH
}

const getPriorityLabelKey = priorityCode => `partner.order-request.priorities.${priorityCode}`

const getPriorityVariant = priorityCode => {
  if (priorityCode === PRIORITY_HIGH) {
    return 'danger'
  }
  if (priorityCode === PRIORITY_NORMAL) {
    return 'primary'
  }
  return 'secondary'
}

export {
  PRIORITY_HIGH,
  PRIORITY_LOW,
  PRIORITY_NORMAL,
  PRIORITY_CODES,
  getPriorityLabelKey,
  getPriorityVariant,
  mapApiPriorityToCode,
  mapPriorityCodeToApiValue,
}
